import { ISO_4217 } from "../../iso-4217";
import { event, GtagEvent } from "./event";
import { Item } from "./item";

export interface AddToCart extends GtagEvent {
    currency:ISO_4217;
    value: number;
    items:Item[]
}
export const  add_to_cart = ($_:AddToCart) => event('add_to_cart',$_);